import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { DefaultWidgetsTemplateDTO } from './useDefaultTemplateQuery';

export interface SaveWidgetTemplateResponse {
  templateId: string;
  name: string;
  template: DefaultWidgetsTemplateDTO;
}

export interface SaveWidgetTemplateParams {
  id: string | null;
  name: string;
  template: DefaultWidgetsTemplateDTO;
}

const saveWidgetTemplate = async ({
  id,
  name,
  template,
}: SaveWidgetTemplateParams): Promise<SaveWidgetTemplateResponse> => {
  return authFetch('/Adviser/PersonalFinanceTemplates/SaveTemplate', {
    method: 'POST',
    ...httpBodyOptions({ id, name, template }, true),
  });
};

export const useWidgetTemplateMutation = () => {
  return useMutation(saveWidgetTemplate);
};
